TYPE_CONTINUE_WATCHING